<template>
  <div
    :class="[
      'toaster tw-fixed tw-toast tw-z-toast',
      toasterPosition,
      (isStatic ? 'toaster-static' : 'toaster-root'),
    ]">
    <div class="toaster-slot tw-w-[21.5rem]">
      <slot v-if="!!isStatic"></slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'FabricToastRack',
    props: {
      position: {
        type: String,
        default: 'top-right'
      },
      isStatic: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        positionMapping:  {
          'top-left': 'tw-top-5 tw-left-5',
          'top-right': 'tw-top-5 tw-right-5',
          'bottom-left': 'tw-bottom-5 tw-left-5',
          'bottom-right': 'tw-bottom-5 tw-right-5',
        },
      }
    },
    computed: {
      toasterPosition() {
        return `${this.positionMapping[this.position]}`
      }
    },
  }
</script>
